<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbItems" hasBreadcrumb hasBackButton />

    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-row class="mc-card__list">
            <b-col v-for="item in visibleItems" :key="item.key" sm="12" md="4" class="mb-3">
              <b-button
                variant="outline-light"
                class="d-block w-100 mc-card__list-item clearfix"
                @click="$router.push({ name: item.routeName })"
              >
                <i class="mc-fa" :class="item.icon"></i>
                <McBadge
                  v-if="item.badge?.condition && item.hasBadge"
                  :text="$t('global.new')"
                  variant="danger"
                  size="medium"
                  type="pill"
                  class="text-uppercase float-end"
                />
                <div class="mc-card__list-item-content">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.subtitle }}</p>
                </div>
              </b-button>
            </b-col>
          </b-row>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import McBadge from '@/components/McBadge'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

export default {
  page: {
    title: 'Template',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McBadge,
  },
  mixins: [Helper],
  data() {
    return {
      title: 'Template',
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      isNewSubmodule: 'identity/isNewSubmodule',
    }),
    breadcrumbItems() {
      return [
        {
          text: 'Pengaturan',
          to: '/setting',
        },
        {
          text: this.title,
        },
      ]
    },
    items() {
      return [
        {
          key: 'fleet-task-cost',
          title: this.$t('setting.homePage.fleetTaskCost'),
          subtitle: this.$t('setting.homePage.textFleetTaskCost'),
          routeName: 'Setting Fleet Task Expense',
          icon: 'icon-outline_calculate',
          isShown: this.hasAccess([
            'financial-record:create',
            'financial-record:read',
            'financial-record:update',
            'financial-record:delete',
          ]),
          hasBadge: false,
          badge: {
            condition: false,
          },
        },
        {
          key: 'delivery-order',
          title: 'Pengiriman',
          subtitle: 'Mengelola template untuk pengiriman.',
          routeName: 'Setting Template Delivery Order',
          icon: 'icon-outline_cube',
          isShown: this.hasAccess(['tms:create', 'tms:read', 'tms:update', 'tms:delete']),
          hasBadge: false,
          badge: {
            condition: false,
          },
        },
        {
          key: 'vehicle-inspection',
          title: this.$t('vehicleInspection.title'),
          subtitle: this.$t('vehicleInspection.subtitle'),
          routeName: 'Setting Template Vehicle Inspection',
          icon: 'icon-outline_clipboard',
          isShown: this.hasAccess([
            'c19a-default-vehicle-inspection:read',
            'c19a-default-vehicle-inspection:create',
            'c19a-default-vehicle-inspection:update',
            'c19a-default-vehicle-inspection:delete',
          ]),
          hasBadge: true,
          badge: {
            condition: this.isNewSubmodule('c19a-default-vehicle-inspection'),
          },
        },
      ]
    },
    visibleItems() {
      return this.items.filter((item) => item.isShown)
    },
  },
}
</script>
